export const escapeHtml = (value = '') =>
  String(value).replace(
    /[&<>"']/g,
    (char) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[
        char
      ])
  );
export const editableHtml = (item) =>
  item?.type === 'html'
    ? item.body || ''
    : (item?.body || '')
        .split('\n')
        .map((line) => `<p>${escapeHtml(line) || '<br>'}</p>`)
        .join('');
export function replaceRichContent(content, index, html, editorDocument) {
  const next = [...content];
  const item = {
    ...(next[index] || {}),
    type: 'html',
    body: html,
    mimeType: 'text/html',
  };
  if (editorDocument) item.editorDocument = editorDocument;
  else delete item.editorDocument;
  if (index < 0) next.unshift(item);
  else next[index] = item;
  return next;
}
